import { render } from "./TableContent.vue?vue&type=template&id=c0ca4974&scoped=true&ts=true"
import script from "./TableContent.vue?vue&type=script&lang=ts"
export * from "./TableContent.vue?vue&type=script&lang=ts"

import "./TableContent.vue?vue&type=style&index=0&id=c0ca4974&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0ca4974"]])

export default __exports__